export enum ConsumptionTrendEnum {
  Increasing = "increasing",
  Decreasing = "decreasing",
  Stable = "stable",
  New = "new",
  NoConsumption = "no_consumption",
}

export type InsightsConsumption = {
  average: number;
  current: number;
  status: ConsumptionTrendEnum;
};

export type UseInsightsConsumptionProps = {
  companyId: number;
  startDate: string;
  endDate: string;
};
